module.exports = __webpack_public_path__ + "00f92ec6bf7c5e454a1d8d86dc34e87c.png";